module.exports = __webpack_public_path__ + "teqbahn-assets/media/7.c91ff3f9.jpg";